import { v4 as uuidv4 } from "uuid";
export class EntryViewModel {
    constructor() {
        this.id = uuidv4();
        this.referenceNumber = "";
        this.description = "";
        this.referenceLink = "";
        this.whyItMatters = "";
        this.state = "";
        this.type = "";
        this.createdBy = "";
        this.updatedBy = "";
        this.updatedOnAsString = "";
        this.createdOnAsString = "";
        this.dateOpenedAsString = "";
        this.upComingEvents = [];
        this.entryActions = [];
        this.entryTags = [];
        this.entryCategories = [];
        this.entryDescriptions = [];
        this.isEntryEditable = false;
        this.amendments = "";
        this.status = "";
        this.lastActionDateAsString = "";
    }
}
export default class EntryView extends EntryViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
